var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid scrollbar-style" }, [
    _vm.showUpload
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "cell-sm-12 cell-md-8" }, [
            _c("input", {
              attrs: {
                type: "file",
                "data-role": "file",
                "data-prepend": ".txt to Upload:"
              },
              on: {
                change: function($event) {
                  return _vm.processFile($event)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell-sm-12 cell-md-4" }, [
            _c(
              "button",
              {
                staticClass: "button primary",
                attrs: { disabled: !_vm.selectedFile && !_vm.uploading },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onUploadFile($event)
                  }
                }
              },
              [_c("span", [_vm._v("Upload")])]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm.selectable
          ? _c("div", { staticClass: "cell-full" }, [
              _vm._v("\n      Click on check button to select\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.list, function(fi, idx) {
          return _c(
            "div",
            {
              key: idx,
              staticClass: "cell-full",
              class: { activated: fi == _vm.selectedItem },
              staticStyle: { display: "flex", "align-items": "center" }
            },
            [
              _c(
                "div",
                { staticStyle: { flex: "0 0 60px", padding: "0px 5px" } },
                [_vm._v(_vm._s(fi.id))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { flex: "0 0 150px", padding: "0px 5px" } },
                [_vm._v(_vm._s(fi.datetime))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1 1 auto",
                    "text-align": "right",
                    padding: "0px 5px"
                  }
                },
                [_vm._v(_vm._s(fi.signatures.join(",")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { flex: "0 0 120px", padding: "0px 5px" } },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button light",
                      on: {
                        click: function($event) {
                          return _vm.onSelect(fi)
                        }
                      }
                    },
                    [_c("span", { staticClass: "mif-checkmark mif-2x" })]
                  )
                ]
              )
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.showProcessor && _vm.selectedItem
      ? _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "cell-full" }, [
              _vm._v("\n      Select processor\n    ")
            ]),
            _vm._v(" "),
            _vm._l(_vm.processors, function(pr, idx) {
              return _c(
                "div",
                {
                  key: idx,
                  staticClass: "cell-full",
                  staticStyle: { display: "flex", "align-items": "center" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { flex: "0 0 60px", padding: "0px 5px" } },
                    [_vm._v(_vm._s(pr.id))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { flex: "1 1 auto", padding: "0px 5px" } },
                    [_vm._v(_vm._s(pr.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { flex: "0 0 60px", padding: "0px 5px" },
                      on: {
                        click: function($event) {
                          return _vm.onRunDAG(pr)
                        }
                      }
                    },
                    [_vm._m(1, true)]
                  )
                ]
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.loading
      ? _c("div", {
          attrs: {
            "data-role": "progress",
            "data-type": "line",
            "data-small": "true"
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "button light" }, [
      _c("span", { staticClass: "mif-cloud-download mif-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "button light" }, [
      _c("span", { staticClass: "mif-play mif-2x" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }